function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import ProgressRing from 'components/ProgressRing';
import ImportIcon from 'svg/import.svg';
import App from 'modules/App';
import Button from 'components/Form/Button';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
var _React_PureComponent;
class ExportDataModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    onClose() {
        this.props.onCloseModal();
    }
    renderActions() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "quaternary",
            labelMessage: App.messages.buttons.cancel,
            className: "btn--block mt-7",
            onClick: ()=>this.onClose()
        });
    }
    renderProgress() {
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex justify-content-center w-100 mb-5",
            children: /*#__PURE__*/ _jsx(ProgressRing, {
                radius: 120,
                stroke: 15,
                progress: this.props.progress,
                isInProgress: this.props.isInProgress,
                StartIcon: ImportIcon
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.EXPORT_DATA_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.buttons[this.props.exportName],
            isInProgress: this.props.isInProgress,
            onClose: ()=>this.onClose(),
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "modal__info mb-5",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.exportDataModal))
                }),
                this.renderProgress(),
                this.renderActions()
            ]
        });
    }
}
_define_property(ExportDataModal, "propTypes", {
    // Implicit props
    exportName: PropTypes.string,
    progress: PropTypes.number,
    openModalId: PropTypes.string,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        exportName: selectors.exportName(state),
        progress: selectors.progress(state),
        isInProgress: selectors.isExportDataInProgress(state),
        hasErrors: selectors.hasExportDataErrors(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onCloseModal: ()=>Promise.all([
                dispatch(App.actions.closeModal()),
                dispatch(actions.exportDataCancel())
            ])
    });
const ConnectedExportDataModal = connect(mapStateToProps, mapDispatchToProps)(ExportDataModal);
export default ConnectedExportDataModal;
